export enum LeadHydrationActionType {
  CREATE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_FAILURE = '@@lead-hydration/CREATE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_FAILURE',
  CREATE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_REQUEST = '@@lead-hydration/CREATE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_REQUEST',
  CREATE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_SUCCESS = '@@lead-hydration/CREATE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_SUCCESS',

  CREATE_LEAD_HYDRATION_CONFIG_FAILURE = '@@lead-hydration/CREATE_LEAD_HYDRATION_CONFIG_FAILURE',
  CREATE_LEAD_HYDRATION_CONFIG_REQUEST = '@@lead-hydration/CREATE_LEAD_HYDRATION_CONFIG_REQUEST',
  CREATE_LEAD_HYDRATION_CONFIG_SUCCESS = '@@lead-hydration/CREATE_LEAD_HYDRATION_CONFIG_SUCCESS',

  DELETE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_FAILURE = '@@lead-hydration/DELETE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_FAILURE',
  DELETE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_REQUEST = '@@lead-hydration/DELETE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_REQUEST',
  DELETE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_SUCCESS = '@@lead-hydration/DELETE_CREDIT_CARD_LEAD_HYDRATION_CONFIG_SUCCESS',

  GET_LEAD_HYDRATION_CONFIGS_BY_SUB_ACCOUNT_UUID_FAILURE = '@@lead-hydration/GET_LEAD_HYDRATION_CONFIGS_BY_SUB_ACCOUNT_UUID_FAILURE',
  GET_LEAD_HYDRATION_CONFIGS_BY_SUB_ACCOUNT_UUID_REQUEST = '@@lead-hydration/GET_LEAD_HYDRATION_CONFIGS_BY_SUB_ACCOUNT_UUID_REQUEST',
  GET_LEAD_HYDRATION_CONFIGS_BY_SUB_ACCOUNT_UUID_SUCCESS = '@@lead-hydration/GET_LEAD_HYDRATION_CONFIGS_BY_SUB_ACCOUNT_UUID_SUCCESS',
}
